export default __webpack_public_path__ + "static/media/diaphragm.fb1e5b13.svg";